import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_B2B_BIZ_USER, IS_CORP_USER, IS_ONPREMISE, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';

export const vigboPaymentRedirect: { url: string; currentPage: boolean } = getFeature('vigbo-payment-redirect') || {
    url: '/home/?action=new-vigbo-tariff-success',
    currentPage: true,
};

/** Продающий empty-state для бесплатников */
export const vigboFeaturesPreviewFree: boolean =
    isFeature('vigbo-features-preview-free') && !IS_ONPREMISE && !IS_CORP_USER && !IS_B2B_BIZ_USER && !IS_PAID_USER;

/** Продающий empty-state для платников */
export const vigboFeaturesPreviewPaid: boolean =
    isFeature('vigbo-features-preview-paid') && !IS_ONPREMISE && !IS_CORP_USER && !IS_B2B_BIZ_USER && IS_PAID_USER;

/** Текст основной кнопки на продающем empty-state */
export const vigboFeaturesPreviewPrimaryBttnText: string = getFeature('vigbo-features-preview-primary-bttn-text') || 'Подключить';

/** Ссылка "О подписке" на продающем emtpy-state */
export const vigboAboutSubUrl: string =
    getFeature('vigbo-about-sub-url') ||
    'https://cloud.mail.ru/promo/mailvigbo/?utm_source=product-interface_cloud&utm_medium=emptystate_web&utm_campaign=mnzphoto_prd_aon_empty_land&utm_term=button_about_subs-mnzphoto_prd_aon_empty_land&mt_link_id=g1buj1';

/** Принудительно включает функционал, доступный после связки аккаунтов */
export const forceVigboLinkedAccount: boolean = isFeature('force-vigbo-linked-account');

/** Список тарифов, для которых доступна интеграция с Vigbo */
export const vigboTariffs: string[] = getFeature('vigbo-tariffs') || [];

/** Ссылки для перехода в Vigbo или иные связанные страницы */
const defaultVigboLinks = {
    cloudAdditionalAgreement: 'https://help.mail.ru/legal/terms/cloud/additional/',
    mailVigboRules: 'https://blog.mail.ru/pravila_mailvigbo/',
    vigboRules: 'https://vigbo.com/agreement',
};
export const vigboLinks: Record<string, string | undefined> = { ...defaultVigboLinks, ...(getFeature('vigbo-links') || {}) };

/** За сколько дней до конца напоминанем о продлении тарифа при помощи модалки */
export const vigboTariffModalRemindDays: number[] = getFeature('vigbo-tariff-modal-remind-days') || [7, 3, 1];

/** За сколько дней до конца напоминанем о продлении тарифа при помощи баннера */
export const vigboTariffBannerRemindDays: number = getFeature('vigbo-tariff-banner-remind-days') || 7;

/** Показываем ли модалку об окончании подписки */
export const vigboTariffEndModal: boolean = isFeature('vigbo-tariff-end-modal');

/** ProductId тарифа, который продаем по умолчанию */
export const vigboDefaultTariff: string = getFeature('vigbo-default-tariff') || 'W1TB_1y_vigbo_discount';

/** Какой тариф предлагаем вернуть, если у пользователя закончился триал */
export const vigboTrialProductsMap: Record<string, string> = getFeature('vigbo-trial-products-map') || {
    W256GB_1m_vigbo_force_trial: 'W256GB_1m_vigbo_discount',
    W256GB_1y_vigbo_discount_force_trial: 'W256GB_1y_vigbo_discount',
    W1TB_1m_vigbo_force_trial: 'W1TB_1m_vigbo_discount',
    W1TB_1y_vigbo_discount_force_trial: 'W1TB_1y_vigbo_discount',
    W2TB_1m_vigbo_force_trial: 'W2TB_1m_vigbo_discount',
    W2TB_1y_vigbo_discount_force_trial: 'W2TB_1y_vigbo_discount',
    W4TB_1m_vigbo_force_trial: 'W4TB_1m_vigbo_discount',
    W4TB_1y_vigbo_discount_force_trial: 'W4TB_1y_vigbo_discount',
};

/** Скрываем кнопку просмотреть галерею */
export const showWatchVigboGallery = isFeature('show-watch-vigbo-gallery');
